import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import "../../styles/navBar.css";
// import { MainSvg } from "img/main";
import { FaRegUserCircle } from "react-icons/fa";
import { GpuSvg } from "img/gpu";
import { IoHome } from "react-icons/io5";
import { PiTreasureChestFill } from "react-icons/pi";

/**
 * NavBar — компонент нижней навигации.
 * Комментарии на русском: компонент рендерит фиксированную панель внизу.
 * Активный таб получает белый контур вокруг иконки и белую подпись.
 */
function NavBar(): JSX.Element {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="navbar-container">
      <nav className="navbar" aria-label="Нижняя навигация">
        <div className="navbar-list">
          {/* Daily bonus / chests */}
          <div className="navbar-item">
            <Link
              to="/daily-bonus"
              className={`navbar-link ${isActive("/daily-bonus") ? "active" : ""}`}
            >
              <span className="icon-wrap" aria-hidden>
                <span className="icon-wrap" aria-hidden>
                  {PiTreasureChestFill({})}
                </span>
              </span>
              <span className="nav-label">Кейсы</span>
            </Link>
          </div>

          {/* Home */}
          <div className="navbar-item">
            <Link to="/home" className={`navbar-link ${isActive("/home") ? "active" : ""}`}>
              <span className="icon-wrap" aria-hidden>
                {IoHome({})}
              </span>
              <span className="nav-label">Дома</span>
            </Link>
          </div>

          {/* GPU */}
          <div className="navbar-item">
            <Link to="/mining" className={`navbar-link ${isActive("/mining") ? "active" : ""}`}>
              <span className="icon-wrap" aria-hidden>
                  <span className="icon-gpu-mod" aria-hidden>
                    <GpuSvg pathname={`${location.pathname}`} />
                </span>
              </span>
              <span className="nav-label">Майнинг</span>
            </Link>
          </div>

          {/* Main (профиль) */}
          <div className="navbar-item">
            <Link to="/" className={`navbar-link ${isActive("/") ? "active" : ""}`}>
              <span className="icon-wrap" aria-hidden>
                {FaRegUserCircle({})}
              </span>
              <span className="nav-label">Профиль</span>
            </Link>
          </div>
        </div>
      </nav>

      <Outlet />
    </div>
  );
}


export default NavBar;
